module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ack"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_c('b', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Earlier versions of these poems appeared in the following journals:")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('div', [_c('br')]), _c('div', [_c('br')]), _c('i', [_vm._v("751 Magazine")]), _vm._v(" — “Maybe Motion Will Save Us All” and “Myth Left in Memory”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("A Public Space")]), _vm._v(" — “Thought For a Stalled World”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Barn Owl Review")]), _vm._v(" — “For the Driftwood I Once Loved” and “Scientific Method”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Bat City Review")]), _vm._v(" — “[Seven years into the longest],” “[A shadow glimpsed inside],” and “[But a thought always hinges]”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Boston Review")]), _vm._v(" — “Goodbye to All That, the Birds Included”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Cannibal")]), _vm._v(" — “Poem in Place of a Fractured Sonnet”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Court Green")]), _vm._v(" — “Natural History”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Diagram")]), _vm._v(" — “In Light of Recent Developments”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Gulf Coast")]), _vm._v(" — “Sonnet”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Horse Less Review")]), _vm._v(" — “Slow Dancing Around What I Really Have to Say”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("La Fovea")]), _vm._v(" — “Self-Portrait with House Slippers and Tap Water”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("The Laurel Review")]), _vm._v(" — “Recalling an Earlier Snow During a Present Storm” and “Song”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Mantis")]), _vm._v(" — “Gathered” and “Harbor”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("New Orleans Review")]), _vm._v(" — “Poem Beginning with a Line from Tranströmer”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Ninth Letter")]), _vm._v(" — “What Movement Sounds Like”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Octopus Magazine")]), _vm._v(" — “I’m Pretty Sure That’s a Hurdle in the Distance”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Parthenon West Review")]), _vm._v(" — “A Thought Before Thought”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Phoebe")]), _vm._v(" — “Reaching for a Lexicon, an Apple No Longer Shining”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Strange New Egg")]), _vm._v(" — “Fragment for an Avoided Disaster” and “Slow Dancing Around What I Really Have to Say”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("Sycamore Review")]), _vm._v(" — “The Last Horse”")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_c('i', [_vm._v("The Tusculum Review")]), _vm._v(" — “Light Bulb Hum” and “Vine”")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', [_c('br')]), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("“As Complete as a Thought Can Be” appeared as a hand-sewn limited edition chapbook from Cannibal Books. Thank you to Katy and Matthew Henriksen.")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', [_c('br')]), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Thank you, also, to Alex Lemon, Wayne Miller, Michael Robins, Kate and Max Greenstreet, James Cihlar, Shannon Jonas, Zachary Schomburg, Matt Hart, Nancy Eimers, William Olsen, and Kimberley Clay.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41def0c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/adam_9781571318602_oeb_ack_r1.vue
// module id = 72
// module chunks = 0